import { useState } from 'react';
import { Button, Input } from 'semantic-ui-react';
import { errorInput, formatCurrency, s } from '../../components/helpers';
import styled from '@emotion/styled';
import Swal from 'sweetalert2/dist/sweetalert2';
import { useHistory } from 'react-router-dom';
import guestService from 'src/services/api/guest';
import { screenSizes } from 'src/assets/styles/Literals';
import { sillaValue } from './LegadoSelectChairs';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';
import GuestPlainData from '../../components/helpers/guests/GuestPlainData';
import { shouldLockGuestIdentity } from '../../components/helpers/guests/guestIdentity';

const DonationComp = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background-color: white;
  padding: 20px 50px;
  .go-back-btn {
    align-self: flex-start;
    margin-left: 0;
    margin-bottom: 1rem;
    margin-right: auto;
    background: transparent;
    color: #1e3a8a;
    border: 1px solid #1e3a8a;
    border-radius: 16px;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 4px 14px;
    cursor: pointer;
    z-index: 200;
  }
  h1 {
    font-size: 40px;
    padding: 20px 0;
    width: 100%;
    text-align: center;
  }
  .donation-form {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .info {
      margin: 0 0 20px 0;
      .subtitle {
        font-size: 22px;
        margin: 0;
      }
      .note {
        font-size: 12px;
      }
    }
    form {
      display: flex;
      flex-wrap: wrap;
      width: 80%;
      justify-content: center;
      div {
        width: 100%;
      }
      .ui.input {
        width: 100%;
        margin: 10px 0;
      }
    }
  }
  @media (max-width: ${screenSizes.tablet}) {
    width: 100%;
    .donation-form {
      width: 100%;
      form {
        width: 100%;
      }
    }
  }
`;

const LegadoDonationForm = (props) => {
  const { inputs, setInputs, category, setCategory, onGuestUpdated } = props;
  const history = useHistory();
  const [loading, set_loading] = useState(false);
  const [errorInputs, set_errorInputs] = useState({});
  const getCreateCaptchaToken = useRecaptchaToken('guest_create');
  const getUpdateCaptchaToken = useRecaptchaToken('guest_update');
  const identityLocked = shouldLockGuestIdentity(inputs);

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs({ ...inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const verifyForm = () => {
    let mandatoryInputs = [
      'name',
      'lastName',
      'identification',
      'type',
      'email',
      'currency',
      'value',
      'email',
      'phone',
    ];

    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    // Additional validation for identification length
    if (inputs.identification && inputs.identification.length <= 5) {
      errorInputs = errorInput({
        errorInputs: errorInputs,
        input: {
          name: 'identification',
          value: inputs.identification.length >= 5,
        },
      });
    }

    // Additional validation for phone length
    if (inputs.phone && inputs.phone.length <= 10) {
      errorInputs = errorInput({
        errorInputs: errorInputs,
        input: {
          name: 'phone',
          value: inputs.phone.length >= 10,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  const submit = (e) => {
    e.preventDefault();
    if (verifyForm()) return Swal.fire('Error', 'Por favor llene todos los campos', 'error');
    createAttendant();
  };
  console.log(inputs);
  const createAttendant = async () => {
    const { id, name, lastName, phone, identification, email, value, type, chairsToCommit } =
      inputs;

    const captchaRequired = !identityLocked && isCaptchaRequired();
    const getToken = id ? getUpdateCaptchaToken : getCreateCaptchaToken;
    const captcha = await getToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    const body = {
      name,
      lastName,
      phone,
      identification,
      email,
      first_register: 'legado',
      chairsToCommit,
      ...(captchaRequired ? { captcha } : {}),
    };

    set_loading(true);
    const persistGuest = identityLocked
      ? Promise.resolve()
      : id
      ? guestService.updateGuest(id, body)
      : guestService.createGuest(body);
    persistGuest
      .then(() => {})
      .catch((error) => {
        if (error.response) console.error(error.response.data.message);
      })
      .finally(() => {
        history.push(
          `/payucheckout?amount=${value}&description=${type}&buyerEmail=${email}&buyerFullName=${name}&identification=${identification}&extra1=${name} ${lastName}`
        );
        set_loading(false);
      });
  };

  const handleBack = () => {
    let backTo = '';
    if (category === 'donateChairs') {
      backTo = 'chairs';
    } else {
      backTo = 'general';
    }
    setCategory(backTo);
    setInputs({
      chairsToCommit: 0,
      chairs: 1,
      valueToCommit: 0,
      identification: inputs.identification,
      phone: inputs.phone,
    });
  };

  return (
    <DonationComp>
      <div className="donation-form">
        <div className="info">
          <button className="go-back-btn" onClick={handleBack}>
            Volver
          </button>
          <h1>Legado</h1>
          <p className="subtitle">
            Cada campo del formulario debe ser respondido para pasar a la zona de donaciones
          </p>
          <p className="note">
            El certificado de donación se expedirá a nombre del tarjetahabiente
          </p>
        </div>
        <form>
          {identityLocked ? (
            <div style={{ width: '100%', marginBottom: 20 }}>
              <GuestPlainData guest={inputs} onGuestUpdated={onGuestUpdated} />
            </div>
          ) : (
            <>
              <div>
                <label htmlFor="name" style={{ display: 'block' }}>
                  Nombre:
                </label>
                <Input
                  placeholder="Nombre completo"
                  name={'name'}
                  value={inputs.name}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'name'} ${
                    errorInputs['name'] ? 'error' : ''
                  }`}
                />
              </div>
              <div>
                <label htmlFor="lastName" style={{ display: 'block' }}>
                  Apellidos:
                </label>
                <Input
                  placeholder="Apellidos"
                  name={'lastName'}
                  value={inputs.lastName}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'lastName'} ${
                    errorInputs['lastName'] ? 'error' : ''
                  }`}
                />
              </div>
              <div>
                <label htmlFor="identification" style={{ display: 'block' }}>
                  Número de identificación:
                </label>
                <Input
                  placeholder="Número de identificación"
                  name={'identification'}
                  type="number"
                  value={inputs.identification}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'identification'} ${
                    errorInputs['identification'] ? 'error' : ''
                  }`}
                />
              </div>
              <div>
                <label htmlFor="phone" style={{ display: 'block' }}>
                  Celular:
                </label>
                <Input
                  placeholder="Celular"
                  name={'phone'}
                  type="number"
                  value={inputs.phone}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'phone'} ${
                    errorInputs['phone'] ? 'error' : ''
                  }`}
                />
              </div>
              <div>
                <label htmlFor="email" style={{ display: 'block' }}>
                  E-Mail:
                </label>
                <Input
                  placeholder="E-Mail"
                  type="email"
                  name={'email'}
                  value={inputs.email}
                  style={{ padding: 0 }}
                  onChange={handleInputs}
                  className={`Registration__input Registration__input-${'email'} ${
                    errorInputs['email'] ? 'error' : ''
                  }`}
                />
              </div>
            </>
          )}
          {!!inputs.chairsToCommit && (
            <div style={{ margin: '20px 0' }}>
              <p>
                Te comprometiste con {inputs.chairsToCommit} silla{s(inputs.chairsToCommit)} en
                total, que equivalen a {formatCurrency(inputs.chairsToCommit * sillaValue)} en pesos
                colombianos.
              </p>
            </div>
          )}
          <div style={{ margin: '20px 0' }}>
            {!!inputs.userAllDonationsTotal && (
              <p>
                Haz donado un total de {formatCurrency(inputs.userAllDonationsTotal)} en pesos
                colombianos.
              </p>
            )}
            <p>
              Puedes donar en diferentes momentos y con distintos valores hasta completar las sillas
              que deseas donar. Puedes volver a esta sección en cualquier momento para consultar tus
              donaciones y agregar más.
            </p>
            <p>Escribe abajo la cantidad de dinero que deseas donar hoy.</p>
          </div>
          {category !== 'donateChairs' && (
            <div>
              <label htmlFor="value" style={{ display: 'block' }}>
                Valor a donar en {inputs.currency}:
              </label>
              <Input
                placeholder="Valor a donar"
                name={'value'}
                type="number"
                value={inputs.value}
                style={{ padding: 0 }}
                onChange={handleInputs}
                className={`Registration__input Registration__input-${'value'} ${
                  errorInputs['value'] ? 'error' : ''
                }`}
              />
            </div>
          )}
          <div>
            <p style={{ margin: '0 ', fontSize: '22px' }}>
              Vas a donar un total de {formatCurrency(inputs.value || 0)} en pesos colombianos
            </p>
            <p style={{ margin: '0 0 10px 0', fontSize: '16px' }}>
              {category !== 'donateChairs' &&
                'Recuerda que cada donacion representa un apoyo para transformar vidas por medio de Jesús.'}
              {category === 'donateChairs' &&
                'Recuerda que cada silla representa una vida transformada por Jesús.'}
            </p>
          </div>
          <div>
            <Button onClick={submit} primary disabled={!inputs.value || loading} loading={loading}>
              Ir a Donar
            </Button>
          </div>
        </form>
      </div>
    </DonationComp>
  );
};
export default LegadoDonationForm;
